/* eslint-disable react/jsx-no-target-blank */

import {AsideMenuItemWithSub} from '../../AsideMenuItemWithSub'
import {AsideMenuItem} from '../../AsideMenuItem'

const Banner = () => {
  

  return (
      <AsideMenuItemWithSub
        to='/banner'
        title= {"Banner"}
        featherIcon={<i className="fab fa-chromecast fs-3"></i>}
      >
        

        <AsideMenuItem
          to='/banner/admin'
          title={"Administrar Banner"}
          biIcon="bi bi-grid-1x2"
        />
        
      </AsideMenuItemWithSub>
  )
}

export default Banner